<template>

    <v-step :step="step" title="Audience">

        <v-form-group label="Segment" caption="Who may receive a message from this campaign.">
            <v-selector
                class="w-500"
                :model="campaign.segment_id"
                :items="segments | segmentsForSelector('All Customers')"
                @input="setParam({ segment_id: $event })">
            </v-selector>
        </v-form-group>

    </v-step>

</template>

<script>

import Step from '@pages/automations-edit/components/Step';

export default {

    components: {
        'v-step': Step,
    },

    props: {
        step: {
            type: Number,
            default: 1,
        },
    },

    computed: {

        campaign() {
            return this.$store.getters['campaign/campaign'];
        },

        segments() {
            return this.$store.getters.project.segments;
        },

    },

    methods: {

        setParam(param) {
            this.$store.commit('campaign/setParam', param);
        },

    },

}

</script>
